import type { NoyauCode, ResumeTraduction } from '@rosetta/shared';

/** Lower case, without accents: "Élève" and "eleve" are the same word for the search. */
export function normaliser(texte: string): string {
  return texte
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}

/**
 * The search and the noyau filter of the history, on the list already loaded. The search
 * looks for what was typed in the title and in the original text, ignoring case and
 * accents; the filter keeps a translation that targets AT LEAST ONE of the checked
 * noyaux (none checked: no filter). Both apply together, and the order is kept.
 */
export function filtrerTraductions<T extends ResumeTraduction>(
  traductions: readonly T[],
  recherche: string,
  noyaux: readonly NoyauCode[],
): T[] {
  const cherche = normaliser(recherche.trim());
  return traductions.filter((traduction) => {
    if (noyaux.length > 0 && !traduction.noyaux.some((noyau) => noyaux.includes(noyau))) {
      return false;
    }
    if (cherche === '') return true;
    return normaliser(`${traduction.titre ?? ''}\n${traduction.texteOrigine}`).includes(cherche);
  });
}
